import { Directive, EventEmitter, HostListener, Output } from '@angular/core'

@Directive({
  selector: '[mbSwipe]'
})
export class SwipeDirective {

  @Output() mbSwipeLeft = new EventEmitter()
  @Output() mbSwipeRight = new EventEmitter()
  @Output() mbSwipeUp = new EventEmitter()
  @Output() mbSwipeDown = new EventEmitter()

  defaultTouch = { x: 0, y: 0, time: 0 }

  @HostListener('touchstart', ['$event'])
  @HostListener('touchend', ['$event'])
  @HostListener('touchcancel', ['$event'])
  handleTouch (event: any) {
    const touch = event.touches[0] || event.changedTouches[0]

    // check the events
    if (event.type === 'touchstart') {
      this.defaultTouch.x = touch.pageX
      this.defaultTouch.y = touch.pageY
      this.defaultTouch.time = event.timeStamp
    } else if (event.type === 'touchend') {
      const deltaX = touch.pageX - this.defaultTouch.x
      const deltaY = touch.pageY - this.defaultTouch.y
      const deltaTime = event.timeStamp - this.defaultTouch.time

      // simulte a swipe -> less than 500 ms and more than 60 px
      if (deltaTime < 500) {
        // touch movement lasted less than 500 ms
        if (Math.abs(deltaX) > 60) {
          // delta x is at least 60 pixels
          if (deltaX > 0) {
            this.onSwipeRight()
          } else {
            this.onSwipeLeft()
          }
        }

        if (Math.abs(deltaY) > 60) {
          // delta y is at least 60 pixels
          if (deltaY > 0) {
            this.onSwipeDown()
          } else {
            this.onSwipeUp()
          }
        }
      }
    }
  }

  onSwipeLeft () {
    this.mbSwipeLeft.emit()
  }

  onSwipeRight () {
    this.mbSwipeRight.emit()
  }

  onSwipeUp () {
    this.mbSwipeUp.emit()
  }

  onSwipeDown () {
    this.mbSwipeDown.emit()
  }
}
